import { createActionCreator } from '../utils/redux'
import * as actions from '../constants/actions'
import fields from '../constants/fields'
import exportStompunkter, { formatHasColumns } from '../export/exportStompunkter'

export const changeExportFormat = createActionCreator(actions.CHANGE_EXPORT_FORMAT, 'format')

export const toggleExportField = createActionCreator(actions.TOGGLE_EXPORT_FIELD, 'field')

export const exportSelection = () => {
	return async (dispatch, getState) => {
		dispatch(startExporting())
		const state = getState()
		const format = state.exportSettings.format
		const ids = state.selectedStompunkter
		const srid = state.srid
		const selectedFields = formatHasColumns(format)
			? fields
				.map(({ field }) => field)
				.filter((field) => state.exportSettings.fields[field])
			: undefined
		try {
			await exportStompunkter({ ids, srid, format, fields: selectedFields })
		}
		catch (error) {
			if (error.fetchError) {
				alert("Kunde inte exportera data.")
			}
			else {
				throw error
			}
		}
		dispatch(doneExporting())
	}
}

export const startExporting = createActionCreator(actions.START_EXPORTING)

export const doneExporting = createActionCreator(actions.DONE_EXPORTING)

//Bara till för Google Analytics.
export const openPdf = createActionCreator(actions.OPEN_PDF)



// WEBPACK FOOTER //
// ./src/actionCreators/export.js